import WineClubs from "../../components/wine-clubs/clubs-definition";
import { PlanState, WineClub } from "./types";

export const stateFromPlanName = (plan: string): PlanState => {
  const [clubKey, variantKey, preferenceKey, frequencyKey] = plan.split("|");

  const club = WineClubs.find((c) => c.key === clubKey);
  const variant = club
    ? club.variants.find((v) => v.key === variantKey)
    : undefined;
  const preference = variant
    ? variant.preferences.find((p) => p.key === preferenceKey)
    : undefined;
  const frequency = club
    ? club.frequencies.find((f) => f.key === frequencyKey)
    : undefined;

  if (
    club === undefined ||
    variant === undefined ||
    preference === undefined ||
    frequency === undefined
  ) {
    return {};
  }

  return { club, variant, preference, frequency };
};

export const defaultStateForClub = (club: WineClub): PlanState => {
  return stateFromPlanName(club.defaultPlan);
};

export const reducer = (
  currentState: PlanState,
  action: { type: string } & PlanState
): PlanState => {
  const { club, variant, preference, frequency } = currentState;

  switch (action.type) {
    case "CHANGE_CLUB":
      return defaultStateForClub(action.club);
    case "CHANGE_VARIANT":
      return {
        club,
        variant: action.variant,
        preference: action.variant.preferences.find(
          (p) => p.key === "standard"
        ),
        frequency,
      };
    case "CHANGE_PREFERENCE":
      return { club, variant, preference: action.preference, frequency };
    case "CHANGE_FREQUENCY":
      return { club, variant, preference, frequency: action.frequency };
    default:
      return currentState;
  }
};
